<style lang="stylus">
    .question-title
        font-size 12px
        line-height 16px
        color #666
        margin 0 20px 20px

    .userTask-question-content
        min-height 348px
        margin  0 20px
        background #fff
        border-radius 8px
        overflow hidden
        background rgba(255, 255, 255, 0.6)
        box-shadow inset 0px 1px 2px rgba(255, 255, 255, 0.5)
        backdrop-filter blur(6px)

        .userTask-question-box
            padding 20px 20px 8px 20px
            .question-inputbox
                display flex
                align-items center
                width 100%
                height 32px
                border 1px solid #E0E0E0
                box-sizing border-box
                border-radius 4px
                margin-bottom 38px

                p
                    font-size 12px
                    line-height 16px
                    color #000
                    margin-left 16px

                .question-line
                    width 1px
                    height 20px
                    background #E0E0E0
                    margin 0 8px

                input
                    outline none
                    border none
                    flex 1
                    height 100%

                input::-webkit-input-placeholder
                    color #00000033

            .question-btn
                display flex
                justify-content center
                align-items center
                float right
                width 72px
                height 28px
                background linear-gradient(99.24deg, #62AEFF 0%, #017FFF 98.57%)
                border-radius 4px
                cursor pointer
                user-select none
                p
                    color #fff
                    font-size 12px
                    line-height 16px
                &.ban
                    background #e5e5e5
                    pointer-events none

        .userTask-question-box1
            .question-list
                display flex
                flex-wrap wrap
                row-gap 24px
                column-gap 20px
                margin-bottom 58px

                &.pc_fit
                    margin-bottom 38px

                    .question-item
                        margin-right 16px
                        margin-bottom 24px

                        &.last-child
                            margin-right auto

                .question-item
                    display flex
                    align-items center
                    justify-content center
                    width 96px
                    height 36px
                    background #017FFF0F
                    border-radius 4px
                    border 1px solid transparent
                    user-select none
                    cursor pointer
                    transition all .2s linear

                    &.active
                        border-color #017fff
                        background #fff

                    &:not(.active):hover
                        border-color #017fff

                    p
                        font-size 12px
                        line-height 16px
                        color #000

        .userTask-question-box2
            .question-list
                display flex
                flex-wrap wrap
                row-gap 16px
                column-gap 23px
                margin-bottom 38px

                &.pc_fit
                    margin-bottom 18px

                    .question-item
                        margin-right 18px
                        margin-bottom 20px

                        &.last-child
                            margin-right auto

                .question-item
                    display flex
                    justify-content center
                    align-content flex-start
                    flex-wrap wrap
                    width 74px
                    height 80px
                    border-radius 4px
                    border 1px solid #017FFF1A
                    user-select none
                    cursor pointer
                    transition border .2s linear

                    &.active
                        border-color #017fff
                        background #fff

                    &:not(.active):hover
                        border-color #017fff

                    img
                        width 40px
                        height 40px
                        margin-bottom 8px
                        margin-top 8px

                    p
                        font-size 12px
                        line-height 16px
                        color #000
</style>

<template>
    <UserTaskModal :show="show" :title="title" :content="content" @closeModal="closeModal">
        <p class="question-title">
            {{ status == 0 ? "您需要绘图的场景行业是？（可选择1~3个）" : "您使用亿图图示是绘制什么图形呢？（可选择1~3个）" }}
        </p>
        <div class="userTask-question-content">
            <div class="userTask-question-box1 userTask-question-box" v-if="status == 0">
                <div class="question-list" :class="{ pc_fit: isPCs }">
                    <div
                        class="question-item"
                        :class="{ active: industrySelected.includes(item.id) }"
                        v-for="item in industryList"
                        :key="item.id"
                        @click="clickItem(item.id, 'industry')"
                    >
                        <p>{{ item.name }}</p>
                    </div>
                </div>
                <div class="question-inputbox">
                    <p>其他</p>
                    <div class="question-line"></div>
                    <input v-model="industryInput" type="text" placeholder="请填写您的行业名称，如有多个请用逗号隔开" />
                </div>
                <div class="question-btn" @click="nextStatus" :class="{ ban: banIndustryBtn }">
                    <p>下一步</p>
                </div>
            </div>
            <div class="userTask-question-box2 userTask-question-box" v-else>
                <div class="question-list" :class="{ pc_fit: isPCs }">
                    <div
                        class="question-item"
                        :class="{ active: shapeListSelected.includes(item.id) }"
                        v-for="item in shapeList"
                        :key="item.id"
                        @click="clickItem(item.id, 'shapeList')"
                    >
                        <img :src="require(`@/public/img/task/trend/${item.svg}.svg`)" alt="" />
                        <p>{{ item.name }}</p>
                    </div>
                </div>
                <div class="question-inputbox">
                    <p>其他</p>
                    <div class="question-line"></div>
                    <input v-model="shapeInput" type="text" placeholder="请填写您常用的绘图类型，如有多个请用逗号隔开" />
                </div>
                <div class="question-btn" @click="confirm" :class="{ ban: banShapeBtn }">
                    <p>完成</p>
                </div>
            </div>
        </div>
    </UserTaskModal>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import UserTaskModal from "./UserTaskModal.vue";
    @Component({
        components: {
            UserTaskModal,
        },
    })
    export default class UserTaskQuestionModal extends Vue {
        @Prop()
        title;
        @Prop()
        content;
        @Prop()
        show;
        @Prop()
        subTaskId;

        industryList = [
            {
                id: 0,
                name: "程序架构",
            },
            {
                id: 1,
                name: "产品经理",
            },
            {
                id: 2,
                name: "商务汇报",
            },
            {
                id: 3,
                name: "读书笔记",
            },
            {
                id: 4,
                name: "软件开发",
            },
            {
                id: 5,
                name: "知识图谱",
            },
            {
                id: 6,
                name: "考研考证",
            },
            {
                id: 7,
                name: "创意策划",
            },
            {
                id: 8,
                name: "法律法务",
            },
            {
                id: 9,
                name: "电路工程",
            },
            {
                id: 10,
                name: "电子商务",
            },
            {
                id: 11,
                name: "商业战略",
            },
            {
                id: 12,
                name: "云服务",
            },
            {
                id: 13,
                name: "家具规划",
            },
        ];
        shapeList = [
            {
                id: 0,
                name: "流程图",
                svg: "basic-flowchart",
            },
            {
                id: 1,
                name: "思维导图",
                svg: "mind-map",
            },
            {
                id: 2,
                name: "组织结构图",
                svg: "organization-chart",
            },
            {
                id: 3,
                name: "基本框图",
                svg: "block-diagram",
            },
            {
                id: 4,
                name: "路线图",
                svg: "roadmap",
            },
            {
                id: 5,
                name: "UML图",
                svg: "uml-model-diagram",
            },
            {
                id: 6,
                name: "平面布置图",
                svg: "plan",
            },
            {
                id: 7,
                name: "基本电路图",
                svg: "basic-electrical",
            },
            {
                id: 8,
                name: "泳道图",
                svg: "cross-functional-vertical",
            },
            {
                id: 9,
                name: "软件架构图",
                svg: "software-architecture",
            },
            {
                id: 10,
                name: "基本网络图",
                svg: "recommended-2",
            },
            {
                id: 11,
                name: "Chen ERD",
                svg: "chen",
            },
        ];
        industrySelected = [];
        industryInput = "";
        shapeListSelected = [];
        shapeInput = "";

        status = 0;

        get banIndustryBtn() {
            return this.industrySelected.length == 0 && this.industryInput == "";
        }
        get banShapeBtn() {
            return this.shapeListSelected.length == 0 && this.shapeInput == "";
        }
        get apiParam() {
            return this.$store.getters.apiParam;
        }
        get isPCs() {
            return this.isPC || false;
        }

        closeModal() {
            this.cleanData();
            this.$emit("closeModal");
        }

        clickItem(id, type) {
            if (type == "industry") {
                let index = this.industrySelected.indexOf(id);
                if (index != -1) {
                    this.industrySelected.splice(index, 1);
                } else {
                    if (this.industrySelected.length >= 3) return;
                    this.industrySelected.push(id);
                }
            } else {
                let index = this.shapeListSelected.indexOf(id);
                if (index != -1) {
                    this.shapeListSelected.splice(index, 1);
                } else {
                    if (this.shapeListSelected.length >= 3) return;
                    this.shapeListSelected.push(id);
                }
            }
        }

        cleanData() {
            this.industrySelected = [];
            this.shapeListSelected = [];
            this.industryInput = "";
            this.shapeInput = "";
            this.status = 0;
        }

        nextStatus() {
            this.status = 1;
        }

        getInputData(status) {
            if (status == 0) {
                let arr = [];
                for (let item of this.industrySelected) {
                    for (let item2 of this.industryList) {
                        if (item == item2.id) {
                            arr.push(item2.name);
                        }
                    }
                }
                let strArr = this.industryInput ? this.industryInput.split(/\,|\，/) : [];
                return arr.concat(strArr);
            } else {
                let arr = [];
                for (let item of this.shapeListSelected) {
                    for (let item2 of this.shapeList) {
                        if (item == item2.id) {
                            arr.push(item2.name);
                        }
                    }
                }
                let strArr = this.shapeInput ? this.shapeInput.split(/\,|\，/) : [];
                return arr.concat(strArr);
            }
        }

        uploadData() {
            // 上传信息至接口
            let list = [];
            list.push(
                this.$edApi.completeUserQuestion({
                    user_id: this.apiParam.id,
                    token: this.apiParam.token,
                    task_id: this.subTaskId[0],
                    names: this.getInputData(0),
                })
            );
            list.push(
                this.$edApi.completeUserQuestion({
                    user_id: this.apiParam.id,
                    token: this.apiParam.token,
                    task_id: this.subTaskId[1],
                    names: this.getInputData(1),
                })
            );
            return Promise.all(list);
        }

        confirm() {
            this.uploadData().then(() => {
                this.$emit("questionEnd");
                this.$emit("closeModal");
            });
        }

        mounted() {}

        created() {}
    }
</script>
